import Form from './form.tsx'
import type { AgentOptionType, DeviceOptionType, EmptyCollectSessionFormType } from './types'

interface CreateSessionModalProps {
  agents: AgentOptionType[]
  devices: DeviceOptionType[]
  onClose: () => void
}

export function CreateSessionModal({ agents, devices, onClose }: CreateSessionModalProps) {
  const emptyCollectSession: EmptyCollectSessionFormType = {
    community_id: '',
    device_id: '',
    user_id: '',
    physical_amount_collected: 0,
    status: '',
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl rounded-lg bg-background p-6 shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-xl font-semibold text-foreground">Créer une session de collecte</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 px-3 py-1 text-sm"
          >
            Fermer
          </button>
        </div>

        <Form
          collect_session={emptyCollectSession}
          agents={agents}
          devices={devices}
          mode="new"
          method="post"
          action="/collect_sessions"
          submitText="Créer une session de collecte"
          onSuccess={onClose}
        />
      </div>
    </div>
  )
}
